import { IChartArea } from './IChartArea';
import { ResizableBase } from './ResizableBase';

export class ChartArea extends ResizableBase implements IChartArea {
    constructor(container: d3.Selection<any>, width: number, height: number) {
        super(container, 'chart-area');
        this.group().append('rect')
            .attr({
                'x': 0,
                'y': 0,
                'width': width,
                'height': height
            })
            .classed('chart-area-rectangle', true);
    }

    resizeFunction(): (width: number, height: number) => void {
        const self = this;
        return (w, h) => {
            self.resize(w, h, self);
        };
    }

    resize(width: number, height: number, obj: this): void {
        try {
            obj.group()
                .select('rect')
                .attr({
                    'width': width,
                    'height': height
                });
        }
        catch (e) {
            console.error(e);
        }
    }
}